<template>
	<nav v-if="topLinks && topLinks?.length > 0" class="layout-header__container-top">
		<Transition name="slide-fade">
			<div v-if="this.isLinksOpened" :class="`d-flex align-items-${this.headerBreakpoint}-center flex-column flex-${this.headerBreakpoint}-row px-4 ps-${this.headerBreakpoint}-0 layout-header__list`">
				<ul
						v-if="topLinks && topLinks?.length > 0"
						:class="`my-4 my-${this.headerBreakpoint}-0 d-flex flex-column flex-${this.headerBreakpoint}-row align-items-${this.headerBreakpoint}-center gap-4 gap-${this.headerBreakpoint}-5`"
				>
					<li class="layout-header__item" v-for="item in topLinks" @click="this.toggleMenuLinks(item.children && item.children?.length > 0)">
						<layout-header-link :item="item" @click-on-children="this.toggleMenuLinks()" type="top"/>
					</li>
				</ul>
			</div>
		</Transition>
	</nav>
	<nav class="layout-header__container layout-header__shadow ">
		<div :class="`container layout-header__1200 h-100 d-flex flex-column flex-${this.headerBreakpoint}-row justify-content-${this.headerBreakpoint}-between align-items-${this.headerBreakpoint}-center px-0`">
			<div :class="`layout-header__logo pe-${this.headerBreakpoint}-0`">
				<router-link :to="{ name: 'home' }" class="d-flex align-items-center">
					<picture>
						<source
								v-if="this.siteStore.currentSite?.logoSrcset"
								type="image/webp"
								:srcset="this.siteStore.currentSite.logoSrcset"
						>
						<img :src="this.siteStore.currentSite?.logoUrl" alt="logo" class="logo" width="408" height="78">
					</picture>
				</router-link>
				<i :class="`fa-solid fa-bars d-${this.headerBreakpoint}-none layout-header__menu-btn`" @click="this.toggleMenuLinks()"></i>
			</div>
			<Transition name="slide-fade">
				<div v-if="this.isLinksOpened" :class="`d-flex align-items-${this.headerBreakpoint}-center flex-column flex-${this.headerBreakpoint}-row px-4 ps-${this.headerBreakpoint}-0 layout-header__list`">
					<ul
							v-if="bottomLinks && bottomLinks?.length > 0"
							:class="`my-4 my-${this.headerBreakpoint}-0 d-flex flex-column flex-${this.headerBreakpoint}-row align-items-${this.headerBreakpoint}-center gap-4 gap-${this.headerBreakpoint}-5`"
					>
						<li class="layout-header__item" v-for="item in bottomLinks" @click="this.toggleMenuLinks(item.children && item.children?.length > 0)">
							<layout-header-link :item="item" @click-on-children="this.toggleMenuLinks()" type="bottom"/>
						</li>
					</ul>
					<language-select
							:class="`mb-4 mb-${this.headerBreakpoint}-0 ms-${this.headerBreakpoint}-3`"
							:textColor="this.textColor"
							:bgColor="this.bgColor"
							:type="this.siteStore.currentSite.language_selector_type"
					/>
				</div>
			</Transition>
		</div>
	</nav>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import LayoutHeaderLink from "./LayoutHeaderLink.vue";
import ScreenWidthChecker from "../../Mixins/ScreenWidthChecker";
import {Breakpoint} from "../../Utils/Breakpoint";
import ButtonUnit from "../Units/ButtonUnit.vue";
import LanguageSelect from "../LanguageSelect.vue";
import {LayoutCssVariables} from "../../Utils/LayoutCssVariables";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";
import {useSiteCheckStore} from "../../Stores/SiteCheck/SiteCheck";
import {LinkPositionTypeEnum} from "@SharedEnums/LinkPositionTypeEnum";
import {SiteCheckInterface} from "@/WebApp/Stores/SiteCheck/Interfaces/SiteCheckInterface";

export default defineComponent({
	name: "LayoutHeader",
	mixins: [ScreenWidthChecker],
	inject: ['emitter'],
	components: {LanguageSelect, ButtonUnit, LayoutHeaderLink},
	setup() {
		return {
			siteStore: useSiteCheckStore(),
		}
	},
	data() {
		return {
			isLoading: false,
			headerBreakpoint: 'lg',
			headerBreakpointValue: Breakpoint.LG,
			isLinksOpened: false,
		}
	},
	mounted() {
		this.isLinksOpened = window.innerWidth >= this.headerBreakpointValue;
	},
	watch: {
		isScreenUnderLg() {
			this.isLinksOpened = !this.isScreenUnderLg;
		},
	},
	computed: {
		currentSite(): SiteCheckInterface {
			return this.siteStore.currentSite;
		},
		topLinks() {
			return this.currentSite.links?.filter(element => element.position === LinkPositionTypeEnum.TOP);
		},
		bottomLinks() {
			return this.currentSite.links?.filter(element => element.position === LinkPositionTypeEnum.BOTTOM);
		},
		bgColor(): string {
			return `var(--${LayoutCssVariables.header.bgColor})`;
		},
		topBackgroundColor(): string {
			return `var(--${LayoutCssVariables.header.topBackgroundColor})`;
		},
		textTopColor(): string {
			return `var(--${LayoutCssVariables.header.textTopColor})`;
		},
		textColor(): string {
			return LayoutCssVariables.header.textColor;
		},
		textColorVar(): string {
			return `var(--${LayoutCssVariables.header.textColor})`;
		},
		buttonShape(): string | ButtonUnitShape {
			// TODO
			// return LayoutCssVariables.header.buttonShape;
			return ButtonUnitShape.ROUNDED
		},
		buttonBgColor(): string {
			return `var(--${LayoutCssVariables.header.buttonBgColor})`;
		},
		buttonTextColor(): string {
			return `var(--${LayoutCssVariables.header.buttonTextColor})`;
		},
	},
	methods: {
		toggleMenuLinks(checkForChildren: boolean = false): void {
			if (window.innerWidth <= this.headerBreakpointValue && !checkForChildren) {
				document.querySelector('html')?.classList.toggle('overflow-hidden');
				document.body.classList.toggle('overflow-hidden');
				this.isLinksOpened = !this.isLinksOpened;
			}
		},
	},
});
</script>

<style scoped>
.layout-header__container {
	background-color: v-bind(bgColor);
}

.layout-header__container-top {
	background-color: v-bind(topBackgroundColor);
	min-height: 36px;
	justify-items: end;
}

.layout-header__list-top {
	background-color: v-bind(topBackgroundColor);
}

.layout-header__menu-btn-top {
	color: v-bind(textTopColor);
}

.layout-header__list {
	background-color: v-bind(bgColor);
}


.layout-header__menu-btn {
	color: v-bind(textColorVar);
}

.button-unit.bordered {
	border-color: v-bind(buttonTextColor);
}

@media (min-width: 992px) {
	.layout-header__list {
		background-color: transparent;
	}
}

.layout-header__shadow {
	box-shadow: inset 0 -4px 4px 0 rgba(0, 0, 0, 0.12);
}


.layout-header__1200 {
	max-width: 1200px !important;
}

@media (min-width: 110px) {
	.layout-header__logo {
		padding-left: 20px;
	}

	.layout-header__menu-btn {
		padding-right: 20px;
	}
}
</style>
